// extracted by css-extract-rspack-plugin
export default {"publicPage":"publicPage-KBkkPl","main":"main-RGZw6H","searchBox":"searchBox-QHUJJj"};